<script>
import Button from 'primevue/button';

export default {
    components: { Button },
    name: 'PartnerLinkAdd',

    props: {
        partnerId: {
            type: Number,
            required: true,
        },
    },

    emits: ['added'],

    data() {
        return {
            slug: '',
            description: '',
            error: null,
        };
    },

    computed: {
        previewUrl() {
            if (!this.slug.trim()) return null;
            return `https://gameartkit.com/?ref=${encodeURIComponent(this.slug.trim())}`;
        },
    },

    methods: {
        async submit() {
            this.error = null;
            try {
                await this.$store.dispatch('addPartnerLink', {
                    partnerId: this.partnerId,
                    data: {
                        slug: this.slug.trim() || undefined,
                        description: this.description.trim() || null,
                    },
                });
                this.slug = '';
                this.description = '';
                this.$emit('added');
            } catch (e) {
                this.error = e?.response?.data?.detail ?? 'Failed to create link.';
            }
        },
    },
};
</script>

<template>
    <div class="link-add-form">
        <div class="link-add-title">New tracking link</div>
        <p v-if="error" class="error-text">{{ error }}</p>
        <div class="link-add-row">
            <div class="link-add-field">
                <label class="link-add-label">Slug</label>
                <input
                    v-model="slug"
                    class="input-field"
                    placeholder="auto-generated if empty"
                />
            </div>
            <div class="link-add-field link-add-field--wide">
                <label class="link-add-label">Description</label>
                <input
                    v-model="description"
                    class="input-field"
                    placeholder="optional"
                />
            </div>
            <Button label="+ Add link" size="small" class="link-add-btn" @click="submit" />
        </div>
        <div v-if="previewUrl" class="url-preview">
            <span class="url-preview-label">Preview:</span>
            <span class="url-preview-text">{{ previewUrl }}</span>
        </div>
    </div>
</template>

<style scoped>
.link-add-form {
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 6px;
    padding: 12px 14px;
    display: flex;
    flex-direction: column;
    gap: 8px;
}
.link-add-title {
    font-size: 0.78rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: #94a3b8;
    margin-bottom: 2px;
}
.link-add-row {
    display: flex;
    align-items: flex-end;
    gap: 10px;
    flex-wrap: wrap;
}
.link-add-field {
    display: flex;
    flex-direction: column;
    gap: 4px;
    flex: 1;
    min-width: 120px;
}
.link-add-field--wide {
    flex: 2;
}
.link-add-label {
    font-size: 0.73rem;
    font-weight: 600;
    color: #64748b;
}
.input-field {
    width: 100%;
    padding: 7px 10px;
    font-size: 0.85rem;
    line-height: 1.4;
    color: #0f172a;
    background: #ffffff;
    border: 1px solid #e2e8f0;
    border-radius: 6px;
    outline: none;
    box-sizing: border-box;
    font-family: inherit;
    transition: border-color 0.15s;
}
.input-field:focus {
    border-color: #93c5fd;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}
.input-field::placeholder {
    color: #94a3b8;
}
.link-add-btn {
    flex-shrink: 0;
    align-self: flex-end;
    white-space: nowrap;
}
.url-preview {
    font-size: 0.78rem;
    color: #64748b;
    display: flex;
    gap: 6px;
    align-items: center;
}
.url-preview-label {
    font-weight: 600;
    color: #94a3b8;
    white-space: nowrap;
}
.url-preview-text {
    font-family: monospace;
    color: #0369a1;
    word-break: break-all;
}
</style>
